import React from 'react';
import { Modal } from './UI';
import { useInactivityTimeout } from '../lib/sessionTimeout';

// Watches for user inactivity on every authenticated page and shows the timeout
// warning. The countdown and sign-out both run through the existing signOut flow
// passed down from App.
export default function SessionTimeoutGuard({ signOut }) {
  const { warning, secondsLeft, staySignedIn } = useInactivityTimeout(
    () => signOut({ expired: true })
  );

  if (!warning) return null;

  return (
    <Modal
      title="Session about to expire"
      onClose={staySignedIn}
      footer={(
        <>
          <button className="btn btn-ghost" onClick={() => signOut({ expired: false })}>Sign Out Now</button>
          <button className="btn btn-primary" onClick={staySignedIn}>Stay Signed In</button>
        </>
      )}
    >
      <div style={{ fontSize: 14, color: 'var(--slate)', lineHeight: 1.55 }}>
        You have been inactive for a while. For your security you will be signed out in{' '}
        <strong style={{ color: 'var(--navy)' }}>{secondsLeft}</strong> second{secondsLeft === 1 ? '' : 's'}.
        <div style={{ marginTop: 8 }}>Choose <strong>Stay Signed In</strong> to continue your session.</div>
      </div>
    </Modal>
  );
}
